module.exports = __webpack_public_path__ + "img/image.adc4e5a9.png";